// eslint-disable-next-line jira/filename-case
import { useEffect } from 'react';
import {
	UniversalCreateButtonLoadExperience,
	UniversalCreateButtonInteractiveExperience,
} from '../experiences.tsx';

const INTERACTIVE_TIMEOUT_MS = 3000; // 3 seconds

// Shared ref to track if interactive experience has completed (success or failure)
const interactiveExperienceCompletedRef = { current: false };

export const useUniversalCreateLoadExperience = (): void => {
	// Measure time from component mount to button painted on screen
	useEffect(() => {
		UniversalCreateButtonLoadExperience.start();

		// Wait for next paint, then mark as success (measures time until button is visible)
		requestAnimationFrame(() => {
			UniversalCreateButtonLoadExperience.success();
		});
	}, []);
};

export const useUniversalCreateButtonInteractiveExperienceStart = (): void => {
	// Start tracking interactive experience on component mount
	useEffect(() => {
		UniversalCreateButtonInteractiveExperience.start();

		// Mark as failure if items don't load within timeout
		const timeoutId = setTimeout(() => {
			if (!interactiveExperienceCompletedRef.current) {
				UniversalCreateButtonInteractiveExperience.failure();
				interactiveExperienceCompletedRef.current = true;
			}
		}, INTERACTIVE_TIMEOUT_MS);

		// Cleanup timeout on unmount
		return () => clearTimeout(timeoutId);
	}, []);
};

export const useUniversalCreateButtonInteractiveExperienceComplete = (): void => {
	// Mark experience as completed and prevent failure() from being called by the timeout
	useEffect(() => {
		interactiveExperienceCompletedRef.current = true;
		UniversalCreateButtonInteractiveExperience.success();
	}, []);
};
